import {
    ShieldCheck,
    CircleCheck,
    HeartPulse,
    Sparkles,
    Activity,
    Syringe,
    Stethoscope,
    Smile,
    Sun,
    Layers,
    Baby,
    Moon,
} from "lucide-react";

export const CONTACTS = {
    phoneDisplay: "039 604 1994",
    phoneHref: "tel:+390396041994",
    whatsappDisplay: "039 604 1994",
    whatsappNumber: "390396041994",
    email: "info@studiomassironi.it",
    address: "Via Sergio De Giorgi 19, 20863 Concorezzo (MB)",
    mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=Via+Sergio+De+Giorgi+19+Concorezzo+MB",
    mapsEmbedUrl:
        "https://maps.google.com/maps?q=Studio%20Dentistico%20Dr.%20Mario%20Massironi%20Via%20Sergio%20De%20Giorgi%2019%20Concorezzo%20MB&z=16&hl=it&output=embed",
    hours: [
        { days: "Lunedì — Venerdì", time: "9:00 – 12:30 · 15:00 – 20:00" },
        { days: "Sabato e Domenica", time: "Chiuso" },
    ],
};

export const SOCIALS = {
    facebook: "https://www.facebook.com/profile.php?id=100069876381826",
    instagram: "https://www.instagram.com/studiomassironi",
};

export const whatsappLink = (message) =>
    `https://wa.me/${CONTACTS.whatsappNumber}?text=${encodeURIComponent(
        message ||
            "Buongiorno, vorrei prenotare una visita presso lo Studio Dentistico Dr. Massironi.",
    )}`;

export const NAV_LINKS = [
    { label: "Home", to: "/", testid: "nav-link-home" },
    { label: "Servizi", to: "/servizi", testid: "nav-link-servizi" },
    { label: "Chi Siamo", to: "/chi-siamo", testid: "nav-link-chi-siamo" },
    { label: "Lo Studio", to: "/studio", testid: "nav-link-studio" },
    { label: "Recensioni", to: "/recensioni", testid: "nav-link-recensioni" },
    { label: "Contatti", to: "/contatti", testid: "nav-link-contatti" },
];

export const MANIFESTO = [
    {
        number: "01",
        title: "Precisione clinica",
        description:
            "Ogni cura unisce competenza ed esperienza: chi ti visita conosce ogni dettaglio del tuo sorriso.",
    },
    {
        number: "02",
        title: "Ascolto senza ansia",
        description:
            "Tempi distesi, spiegazioni chiare e protocolli delicati: la paura del dentista si cura prima di tutto con l'ascolto.",
    },
    {
        number: "03",
        title: "Tecnologia al servizio della cura",
        description:
            "Diagnostica digitale e TAC 3D in sede per interventi più precisi, rapidi e minimamente invasivi.",
    },
    {
        number: "04",
        title: "Trasparenza che dura nel tempo",
        description:
            "Piani di cura chiari fin dal primo preventivo, materiali certificati biocompatibili e controlli programmati negli anni.",
    },
];

export const SERVICES = [
    {
        id: "igiene-prevenzione",
        icon: ShieldCheck,
        name: "Igiene Orale & Prevenzione",
        short:
            "Pulizia professionale e protocolli di prevenzione personalizzati per mantenere il sorriso sano nel tempo.",
        long: "La prevenzione è la cura più efficace e meno costosa. Programmiamo richiami di igiene professionale su misura, con strumentazione delicata e istruzioni domiciliari personalizzate.",
        points: [
            "Igiene professionale con ablatore e AIR Flow",
            "Sigillature e fluoroprofilassi per i più piccoli",
            "Richiami di prevenzione programmati",
        ],
    },
    {
        id: "conservativa",
        icon: CircleCheck,
        name: "Odontoiatria Conservativa",
        short:
            "Otturazioni e intarsi invisibili in composito biocompatibile, per preservare il dente naturale.",
        long: "Quando una carie va curata, lo facciamo preservando il più possibile il tessuto sano: ricostruzioni estetiche in composito e intarsi, invisibili alla vista.",
        points: [
            "Otturazioni estetiche del colore del dente",
            "Intarsi estetici in ceramica",
            "Approccio minimamente invasivo",
        ],
    },
    {
        id: "endodonzia",
        icon: HeartPulse,
        name: "Endodonzia",
        short:
            "Cure canalari accurate e indolori per salvare il tuo dente naturale.",
        long: "La devitalizzazione non deve fare paura: con anestesia efficace, strumenti meccanici di ultima generazione e controllo radiografico digitale, trattiamo i canali radicolari preservando il tuo dente naturale.",
        points: [
            "Trattamenti canalari in singola o poche sedute",
            "Ritrattamenti di devitalizzazioni precedenti",
            "Protocolli anestetici personalizzati",
        ],
    },
    {
        id: "protesi-laboratorio",
        icon: Sparkles,
        name: "Protesi Dentarie Su Misura",
        short:
            "Corone, ponti e faccette progettati nei minimi dettagli per restituire piena funzionalità ed estetica naturale al tuo sorriso.",
        long: "Il Dr. Massironi è odontoiatra e odontotecnico, conosce la protesi dal banco alla bocca: ogni lavoro definitivo viene scelto e controllato insieme a te, dal colore alla forma.",
        points: [
            "Corone e ponti in ceramica, zirconio, disilicato di litio e metallo ceramica",
            "Provvisori realizzati direttamente in studio",
            "Faccette estetiche su misura",
            "Protesi mobili e riparazioni rapide",
        ],
    },
    {
        id: "implantologia",
        icon: Activity,
        name: "Implantologia",
        short:
            "Denti fissi al posto di quelli mancanti grazie a un'accurata pianificazione digitale, per un ripristino sicuro, preciso e confortevole.",
        long: "Sostituiamo i denti mancanti con impianti in titanio pianificati digitalmente, con protocolli a carico differito per la massima predicibilità nel tempo.",
        points: [
            "Pianificazione implantare digitale 3D",
            "Protocolli a carico differito",
            "Provvisori su impianto rimovibili in poliammide",
            "Controlli e manutenzione programmati",
        ],
    },
    {
        id: "chirurgia-orale",
        icon: Syringe,
        name: "Chirurgia Orale",
        short:
            "Estrazioni, denti del giudizio e piccola chirurgia con protocolli delicati e attenzione al decorso.",
        long: "Dalle estrazioni semplici ai denti del giudizio inclusi, affrontiamo la chirurgia orale con protocolli atti a ridurre al minimo il disagio post-operatorio e con un'assistenza diretta nei giorni successivi.",
        points: [
            "Estrazioni semplici e complesse",
            "Denti del giudizio inclusi",
            "Assistenza diretta nel post-operatorio",
        ],
    },
    {
        id: "patologia",
        icon: Stethoscope,
        name: "Patologia Orale & Biopsie",
        short:
            "Diagnosi precoce di lesioni e neoformazioni del cavo orale, con biopsie eseguite in sede.",
        long: "Una lesione che non guarisce va sempre controllata. Lo screening delle mucose fa parte di ogni nostra visita e, quando serve, il Dr. Amici — chirurgo maxillo-facciale — esegue la biopsia direttamente in studio, con refertazione istologica.",
        points: [
            "Screening delle mucose",
            "Biopsie in sede dal chirurgo maxillo-facciale",
            "Refertazione istologica e follow-up",
        ],
    },
    {
        id: "ortodonzia",
        icon: Smile,
        name: "Ortodonzia Invisibile & Tradizionale",
        short:
            "Allineatori trasparenti e apparecchi tradizionali per adulti e bambini, per un sorriso allineato.",
        long: "Denti dritti a ogni età: dagli allineatori trasparenti quasi invisibili agli apparecchi tradizionali per i casi più complessi, con la supervisione del Dr. Cantù, ortodontista esclusivista. Il piano di trattamento viene studiato sul tuo viso e sui tuoi tempi.",
        points: [
            "Allineatori trasparenti rimovibili",
            "Ortodonzia tradizionale per casi complessi",
            "Trattamenti intercettivi per bambini",
        ],
    },
    {
        id: "estetica",
        icon: Sun,
        name: "Estetica Dentale",
        short:
            "Sbiancamento professionale e faccette in ceramica per un sorriso luminoso e naturale.",
        long: "Un sorriso bello è un sorriso che sembra il tuo. Sbiancamenti professionali controllati e faccette in ceramica scelte insieme a te, nel colore e nella forma giusti per il tuo viso.",
        points: [
            "Sbiancamento professionale controllato",
            "Faccette in ceramica su misura",
            "Ricostruzioni estetiche del sorriso",
        ],
    },
    {
        id: "parodontologia",
        icon: Layers,
        name: "Parodontologia",
        short:
            "Diagnosi e cura delle gengive e dei tessuti di sostegno, per fermare la parodontite.",
        long: "Sanguinamento gengivale e recessioni non vanno ignorati: valutiamo la salute dei tessuti di sostegno e impostiamo terapie parodontali non chirurgiche e programmi di mantenimento a lungo termine.",
        points: [
            "Terapia non chirurgica (levigatura radicolare)",
            "Programmi di mantenimento personalizzati",
        ],
    },
    {
        id: "gnatologia",
        icon: Moon,
        name: "Gnatologia",
        short:
            "Diagnosi e cura del bruxismo e dei disturbi dell'articolazione mandibolare, per proteggere denti e muscoli.",
        long: "Digrigni i denti di notte, senti tensione ai muscoli o rumori all'apertura della bocca? Valutiamo l'equilibrio tra denti, muscoli e articolazione temporo-mandibolare e realizziamo bite personalizzati per proteggere i denti dall'usura e alleviare i dolori muscolari e cervicali.",
        points: [
            "Diagnosi del bruxismo e del serramento",
            "Bite notturni su misura per proteggere i denti",
            "Gestione dei disturbi dell'articolazione temporo-mandibolare",
        ],
    },
    {
        id: "pedodonzia",
        icon: Baby,
        name: "Pedodonzia",
        short:
            "Odontoiatria dedicata ai bambini, in un ambiente rassicurante e senza fretta.",
        long: "La prima esperienza dal dentista segna il rapporto con la cura per tutta la vita. Accogliamo i più piccoli con tempi distesi, gioco e prevenzione: sigillature, fluoroprofilassi e controlli periodici.",
        points: [
            "Primo approccio graduale e giocoso",
            "Sigillature dei molari permanenti",
            "Educazione all'igiene per bambini e genitori",
        ],
    },
];

export const FEATURED_SERVICES = [
    "protesi-laboratorio",
    "implantologia",
    "ortodonzia",
    "estetica",
    "igiene-prevenzione",
    "endodonzia",
];

export const REVIEWS = [
    {
        name: "Carlo Orsenigo",
        service: "Recensione Google",
        text: "Tramite amici abbiamo avuto la fortuna di conoscere lo Studio Dentistico del Dott. Mario Massironi. Ci siamo rivolti a lui dopo alcune spiacevoli esperienze con nostra figlia. Fin dal primo momento ci siamo sentiti accolti, capiti e a casa: un ambiente professionale, pulitissimo, e uno staff pronto a trovare le soluzioni migliori per ogni problema. Il Dott. Massironi è competente, gentile, disponibile e molto attento alle esigenze dei pazienti. Oggi tutta la nostra famiglia si affida al suo studio. Ottimo anche il rapporto qualità-prezzo. Che dire: semplicemente fantastico.",
        rating: 5,
    },
    {
        name: "Sabrina Bagatti",
        service: "Recensione Google",
        text: "Il Dr. Mario è un professionista eccellente, così come i suoi collaboratori. Studio pulitissimo, puntuali, onesti e molto delicati: mi sono sentita subito a mio agio, lo consiglio!",
        rating: 5,
    },
    {
        name: "Daniele Soppelsa",
        service: "Recensione Google",
        text: "Mai più un altro odontoiatra. Da quando lo conosco, e stiamo parlando di più di 30 anni, non esiste nessun altro. Un professionista di altissimo livello, con una visione e un approccio ai problemi fuori dagli schemi, soluzioni definitive e una cura maniacale sia del risultato sia del paziente. Disponibilità assoluta.",
        rating: 5,
    },
    {
        name: "Marilena Scotti",
        service: "Recensione Google",
        text: "Professionalità e gentilezza, empatia ed esperienza sono garanzia di un buon percorso di cura e di ottimo risultato. La paura svanisce e il viso si rilassa in un sorriso grato.",
        rating: 5,
    },
    {
        name: "Ale",
        service: "Recensione Google",
        text: "Ottimo professionista, mette a proprio agio il paziente, molto minuzioso nel suo lavoro, attento a ogni dettaglio.",
        rating: 5,
    },
    {
        name: "Jacopo",
        service: "Recensione Google",
        text: "Sono persone eccellenti e non solo per il lavoro che fanno, lo sono a 360 gradi.",
        rating: 5,
    },
    {
        name: "Federico Sala",
        service: "Recensione Google",
        text: "Da 10 anni il mio dentista di fiducia!",
        rating: 5,
    },
    {
        name: "Massimo Guagliumi",
        service: "Recensione Google",
        text: "Un ottimo professionista, sempre disponibile.",
        rating: 5,
    },
    {
        name: "Anna Fanelli",
        service: "Recensione Google",
        text: "Ottimo dentista.",
        rating: 5,
    },
];

export const GOOGLE_RATING = {
    score: "5,0",
    count: 9,
    url: "https://www.google.com/maps/search/Studio+Dentistico+Dr.+Mario+Massironi+Via+Sergio+De+Giorgi+19+Concorezzo",
    reviewUrl: "https://www.google.com/maps/search/?api=1&query=Massironi%20Dr.%20Mario%20Via%20Sergio%20De%20Giorgi%2019%20Concorezzo&query_place_id=",
};

export const IMAGES = {
    hero: "/images/studio-1.webp",
    heroHome: "/images/hero-home.webp",
    studio1b: "/images/studio-1b.webp",
    studio2: "/images/studio-2.webp",
    studio2b: "/images/studio-2b.webp",
    studio2c: "/images/studio-2c.webp",
    tac: "/images/tac.webp",
    tac2: "/images/tac-2.webp",
    tacPaziente: "/images/tac-paziente.webp",
    dottore: "/images/dottore.webp",
    dottoreRitratto: "/images/dottore-ritratto.webp",
    dottoreMonitor: "/images/dottore-monitor.webp",
    accettazione: "/images/accettazione.webp",
    attesa1: "/images/attesa-1.webp",
    attesa2: "/images/attesa-2.webp",
    attesa3: "/images/attesa-3.webp",
    stock1: "/images/stock-1.webp",
    stock2: "/images/stock-2.webp",
    stock3: "/images/stock-3.webp",
    stock4: "/images/stock-4.webp",
    stock5: "/images/stock-5.webp",
};

export const GALLERY = [
    { src: "/images/attesa-2.webp", caption: "La sala d'attesa", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: "/images/accettazione.webp", caption: "L'accettazione", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: "/images/studio-2b.webp", caption: "Lo studio 2", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
    { src: "/images/attesa-1.webp", caption: "La sala d'attesa", span: "lg:col-span-6", ratio: "aspect-[4/3]" },
];

export const FAQ = [
    {
        q: "La prima visita è impegnativa?",
        a: "No: è un colloquio conoscitivo con esame della bocca e, se serve, una radiografia. Alla fine hai un piano di cura chiaro con tempi e costi, senza nessun obbligo.",
    },
    {
        q: "Ho paura del dentista: come mi aiutate?",
        a: "Con tempi distesi, spiegazioni passo passo e protocolli anestetici efficaci. La maggior parte dei nostri pazienti ansiosi torna volentieri: la fiducia si costruisce una visita alla volta.",
    },
    {
        q: "Ricevo sempre un preventivo scritto?",
        a: "Sì, sempre. Prima di iniziare qualsiasi cura ricevi un preventivo dettagliato: niente sorprese, decidi tu con calma.",
    },
    {
        q: "Posso dilazionare i pagamenti?",
        a: "Nella maggior parte dei casi sì: parliamone in studio e troviamo insieme una soluzione sostenibile per il tuo piano di cura.",
    },
    {
        q: "Cosa faccio in caso di urgenza?",
        a: "Chiamaci subito allo 039 604 1994: per le urgenze facciamo il possibile per darti priorità in giornata.",
    },
    {
        q: "Dove si trova lo studio?",
        a: "In Via Sergio De Giorgi 19 a Concorezzo (MB), a pochi minuti da Monza e Agrate. La TAC 3D è direttamente in sede: niente viaggi in altri centri diagnostici.",
    },
];

export const MARQUEE_WORDS = [
    "Ortodonzia Invisibile",
    "Implantologia",
    "Estetica Dentale",
    "Igiene & Prevenzione",
];
